import { Button as MuiButton } from "@mui/material";
import { useStyles } from "./style";
//import { ChartsVoronoiHandlerProps } from "@mui/x-charts";

export interface ApaButtonProps {
  children: React.ReactNode;
  color?: "primary" | "secondary" | "tertiary" | "destructive" | "text";
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}

export const Button = ({
  children,
  className,
  color,
  disabled = false,
  icon,
  onClick,
}: ApaButtonProps) => {
  const classes = useStyles();

  return (
    <MuiButton
      variant="contained"
      className={`
      ${color ? classes[color] : ""} ${classes.button} ${className}`}
      disabled={disabled}
      startIcon={icon && <span className={classes.iconButton}>{icon}</span>}
      onClick={onClick}
    >
      {children}
    </MuiButton>
  );
};
